var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top_nav"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row end-xs"},[_c('need-help'),_c('log-out-button'),_c('language-switcher')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }